import { LegacyEpisodePlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useReadPlayerBaseInfo } from '@/scenarios/legacy-player/components/player-manager/hooks/use-read-player-base-info';

export function useReadEpisodePlayerBaseInfo(
    contentId: string
): LegacyEpisodePlayerBaseInfoContent | undefined {
    const data = useReadPlayerBaseInfo(contentId);

    if (data?.content?.__typename === 'Episode') {
        return data.content;
    }

    return undefined;
}
